import React from "react";
import { NavLink } from "react-router-dom";
import SearchMatch from "../Home/SearchMatch";

const NavBarWithSearch = ({ hideSearch }) => {
  const NavLinks = [
    { to: "/", id: "home", displayName: "DotaTo" },
    { to: "/heroes/all", id: "heroes", displayName: "Heroes" },
    { to: "/items/all", id: "items", displayName: "Items" },
  ];

  return (
    <div className="navBarWrapper">
      <div
        style={{
          display: "flex",
          padding: "20px 20px",
          justifyContent: "space-between",
          alignItems: "baseline",
        }}
      >
        <div>
          {NavLinks.map((item, index) => {
            return (
              <NavLink
                className="navbarItem"
                activeclassname="active"
                to={item.to}
                id={item.id}
                key={index}
              >
                {item.displayName}
              </NavLink>
            );
          })}
        </div>
        {hideSearch !== "True" && <SearchMatch />}
      </div>
    </div>
  );
};

export default NavBarWithSearch;
